import React from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import renderNothing from 'recompose/renderNothing';
import branch from 'recompose/branch';
import get from 'lodash.get';
import ExtraUserInformationFormModal from './ExtraUserInformationFormModal';
import styles from './SetOnHomeHSExtraInformation.css';
import Input from '../Forms/Input';
import trimWhiteSpace from '../../utils/trimWhiteSpace';
import { STUDENT_VIEW } from '../../redux/app';

const validateId = (val) => {
    if (val == null || trimWhiteSpace(val) === '') {
        return 'Please provide your Student Id';
    }
    return undefined;
};

const LakeCountyExtraInformation = ({ ...props }) => (<ExtraUserInformationFormModal
    title="Welcome to College of Lake County!"
    subtitle="Please provide your Student ID below to continue."
    {...props}
>
    <Field
        className={styles.field}
        name="studentId"
        label="Student Id"
        component={Input}
        validate={validateId}
    />
</ExtraUserInformationFormModal>);

export default compose(
    connect(({ me, app, auth }) => ({
        show: (me &&
            !me.studentId &&
            app.view === STUDENT_VIEW &&
            Number(auth.level) === 5),
        initialValues: {
            mobilePhone: get(me, 'studentId'),
            secondaryEmail: get(me, 'secondaryEmail'),
        },
    })),
    branch(
        ({ show }) => !show,
        renderNothing,
    ),
)(LakeCountyExtraInformation);



// WEBPACK FOOTER //
// ./src/client/Components/ExtraUserInformationLakeCounty/LakeCountyExtraInformation.js